import api, { LOGIN_DELAY_MS } from '../../api';
import { User } from '@/types/user';
import { AppStore } from '..';
import errorReporter from '../../utils/errorReporter';
import GetShopInfo from './GetShopInfo';
import GetRecaptchaVerificationToken from './GetRecaptchaVerificationToken';

export default async function SignIn(
  store: AppStore,
  args: {
    email: string;
    password: string;
    preventRedirectToAccountPage?: boolean;
    onSuccessRedirectTo?: string | null;
    onError?: (a: { errorMessage?: string; errorType?: string }) => void;
  },
) {
  const { email, password, preventRedirectToAccountPage, onSuccessRedirectTo, onError } = {
    preventRedirectToAccountPage: false,
    ...args,
  };

  store.dispatch({
    type: 'SIGN_IN_START',
  });

  const RecaptchaVerificationToken = await GetRecaptchaVerificationToken(store, {
    action: 'login',
  });

  const response = await api.dispatch<User>('AuthenticateUser', store, {
    App: 'Web',
    Email: email,
    Password: password,
    RecaptchaVerificationToken,
    RecaptchaSiteKey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
  });

  if (!response.Success) {
    store.dispatch({
      type: 'SIGN_IN_FAIL',
      message: response.Error,
    });

    onError?.({
      errorMessage: response.Error,
      errorType: response.ErrorType,
    });

    return;
  }

  setTimeout(() => {
    api.resetSession();
    store.dispatch({
      type: 'SIGN_IN_SUCCESS',
      user: response.Result,
      authenticatingUser: response.Result,
    });

    if (onSuccessRedirectTo) {
      window.location.href = onSuccessRedirectTo;
    } else if (!preventRedirectToAccountPage) {
      window.location.href = '/account';
    } else {
      // If we're staying on the same page, redirect to the page we're on,
      // stripping off email and temppass querystring arguments.
      const searchParams: URLSearchParams = new URLSearchParams(window.location.search);
      let redirectTo: string = window.location.pathname;
      let searchParamsString: string = '';
      searchParams.forEach((value, key) => {
        if (key !== 'temppass' && key !== 'email') {
          if (searchParamsString === '') {
            searchParamsString = `${key}=${value}`;
          } else {
            searchParamsString = `${searchParamsString}&${key}=${value}`;
          }
        }
      });

      if (searchParamsString !== '') {
        redirectTo = `${redirectTo}?${searchParamsString}`;
      }

      window.history.pushState({}, '', redirectTo);
    }
    errorReporter.setContext({
      user_email: response.Result.LoginEmail,
      user_id: response.Result.ID,
      user: response.Result,
    });

    GetShopInfo(store, {
      forceRefresh: true,
    });
  }, LOGIN_DELAY_MS);
}
